module.exports = __webpack_public_path__ + "static/media/ram_cover.5a2dbbd4.jpg";